import React ,{useEffect} from 'react';
import PopUp from '../../GeneralComponents/PopUp';
import ClickedDublicatePagePopUp from './ClickedDuplicatePagePopUp';

/*
This component renders a pop up that is being displayed when there is a unsaved page and user tries to dublicate a page.
It asks the user to save - dont save or cancel.
*/
const ValidationDublicatePage = (props) => {

    const {
        openAlert,
        setOpenAlert,
        newPageClicked,
        savedPageClicked,
        selectedProject,
        selectedPage
    } = props;
    
    const [openDuplicatePage, setOpenDuplicatePage] = React.useState(false);
    const [pageName, setPageName] = React.useState('');

    useEffect( () =>{
        if(selectedPage > -1 && selectedProject > -1){

            const tempData=JSON.parse(localStorage.getItem('data'));

            if (tempData[selectedProject] !== undefined && tempData[selectedProject.pages !== undefined]){
                const tempPageName = tempData[selectedProject].pages[selectedPage].name;
                setPageName(tempPageName);
            }
        }
    },[selectedProject,selectedPage])

    //  This function is fired when user clicks dont save.It closes the pop up and goes to creation of new dublicate page
    const handleDontSave = () => {
        setOpenAlert(false);
        setOpenDuplicatePage(true);
    }

    //  This function is fired when user clicks dont save.It closes the pop up, saves the previous page and goes to creation of new dublicate page.
    const handleSave = () => {
        savedPageClicked(); 
        setOpenAlert(false);   
        setOpenDuplicatePage(true);
    }

    return (
		<>
            <PopUp
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                handleCancel={handleDontSave}
                handleConfirm={handleSave}    
                title={`Do you want to save ${pageName} ?`}
                insideDescription ={<div style={{display: 'flex',flexDirection: 'column'}}><div style={{display: 'flex', alignSelf: 'center'}}>A new duplicated page will be created.</div><div>All changes will be lost if you create a new duplicate page.</div></div>}
                confirmText='Save'
                cancelText='Cancel'
            />
            <ClickedDublicatePagePopUp
                openDuplicatePage={openDuplicatePage}
                setOpenDuplicatePage={setOpenDuplicatePage}
                selectedProject={selectedProject}
                selectedPage={selectedPage}
                newPageClicked={newPageClicked}
            />
            
		</>
		)
}



export default ValidationDublicatePage;